<template>
  <div class="box">
    <div class="box-header">
      <h4 class="box-title">
        <i class="icofont-listine-dots"></i> {{ tituloTabela }}
      </h4>
      <vue-select
        name="tipo-acompanhamento"
        v-model="indicador"
        class="select-tipo-acompanhamento"
        :clearable="true"
        :options="optionsTipoAcompanhamento"
        label="label"
        placeholder="Tipo acompanhamento"
        @input="onChangeSelectTipoAcompanhamento"
        :disabled="disabledSelectResultado"
      >
        <template slot="option" slot-scope="option">
          {{ option.label }}
        </template>
        <div slot="no-options">Não há opções correspondentes</div>
      </vue-select>
    </div>
    <div class="box-body">
      <table
        class="table table-responsive table-bordered text-center table2"
        id="table"
      >
        <thead>
          <tr>
            <th>Por</th>
            <th>
              Numerador
              <span
                v-b-tooltip.hover
                title="Pessoas com atendimento"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              Denominador
              <span
                v-b-tooltip.hover
                title="Pessoas vinculadas"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              Resultado
              <span
                v-b-tooltip.hover
                title="Percentual de pessoas acompanhadas"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Município</td>
            <td class="text-center font-weight-bold">
              <loader :value="municipio.numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="municipio.denominador"
                :loading="loading"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="municipio.resultado"
                :loading="loading"
                :isPercentage="true"
              ></loader>
            </td>
          </tr>
          <tr>
            <td>Equipe</td>
            <td class="text-center font-weight-bold">
              <loader :value="equipe.numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader :value="equipe.denominador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="equipe.resultado"
                :loading="loading"
                :isPercentage="true"
              ></loader>
            </td>
          </tr>
          <tr>
            <td>ACS</td>
            <td class="text-center font-weight-bold">
              <loader :value="acs.numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader :value="acs.denominador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="acs.resultado"
                :loading="loading"
                :isPercentage="true"
              ></loader>
            </td>
          </tr>
        </tbody>
      </table>
      <FonteEsusPecGlobal />
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  components: {
    Loader,
  },
  props: {
    disabledSelectResultado: {
      type: Boolean,
      default: false,
    },
    resetarSelectTabelaResultado: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    municipio: {
      type: Object,
      default: () => {},
    },
    equipe: {
      type: Object,
      default: () => {},
    },
    acs: {
      type: Object,
      default: () => {},
    },
    selectedTipoAcompanhamento: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tituloTabela: '',
      indicador: null,
      optionsTipoAcompanhamento: [
        { value: 'pessoas_acompanhadas', label: 'Pessoas acompanhadas' },
        // { value: 'atendimento_medicina', label: 'Atendimento medicina' },
        // { value: 'atendimento_enfermagem', label: 'Atendimento enfermagem' },
        // {
        //   value: 'atendimento_outros_profissionais',
        //   label: 'Atendimento outros profissionais',
        // },
        // { value: 'atendimento_odonto', label: 'Atendimento odonto' },
        // { value: 'visitas_domiciliares', label: 'Visitas domiciliares' },
        // { value: 'atendimento_coletivo', label: 'Atendimento coletivo' },
        // { value: 'procedimentos', label: 'Procedimentos' },
      ],
    }
  },
  mounted() {
    this.indicador = this.$props.selectedIndicador
  },
  watch: {},
  methods: {
    onChangeSelectTipoAcompanhamento(indicador) {
      switch (indicador.value) {
        case 'pessoas_acompanhadas':
          this.tituloTabela = 'Pessoas atendidas ou acompanhadas'
          break
        case 'atendimento_medicina':
          this.tituloTabela = 'Pessoas com atendimento individual'
          break
        case 'atendimento_enfermagem':
          this.tituloTabela = 'Pessoas com atendimento individual'
          break
        case 'atendimento_outros_profissionais':
          this.tituloTabela = 'Pessoas com atendimento individual'
          break
        case 'atendimento_odonto':
          this.tituloTabela = 'Pessoas com atendimento odontológico'
          break
        case 'visitas_domiciliares':
          this.tituloTabela = 'Visitas domiciliares'
          break
        case 'atendimento_coletivo':
          this.tituloTabela = 'Atendimento coletivo'
          break
        case 'procedimentos':
          this.tituloTabela = 'Procedimentos'
          break
        default:
          break
      }
      this.$emit('onChangeSelectTipoAcompanhamento', indicador)
    },
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
